module.exports = __webpack_public_path__ + "img/builder-7.72997450.webp";